import { render, staticRenderFns } from "./Odontograma.vue?vue&type=template&id=3c1eda80&scoped=true&"
import script from "./Odontograma.vue?vue&type=script&lang=ts&"
export * from "./Odontograma.vue?vue&type=script&lang=ts&"
import style0 from "./Odontograma.vue?vue&type=style&index=0&id=3c1eda80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1eda80",
  null
  
)

export default component.exports